import { Main } from 'components/Main';
import Page from 'components/Page';
import * as React from 'react';
import { Spinner } from 'components/Spinner';
const AdminEditCourtPage = React.lazy(() => import(/* webpackChunkName: "AdminEditCounty" */ './Page'));
export const AdminEditCounty = () => (React.createElement(Page, { title: "Administrator Edit County" },
    React.createElement(Main, { sidebar: true },
        React.createElement(React.Suspense, { fallback: React.createElement(Spinner, { full: true }) },
            React.createElement(AdminEditCourtPage, null)))));
